import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="mx-auto flex min-h-[70vh] max-w-2xl flex-col items-center justify-center gap-4 text-center"
         data-testid="not-found-page">
      <span className="grid h-11 w-11 place-items-center rounded-[14px] bg-primary/10">
        <Compass className="h-5 w-5 text-primary" />
      </span>
      <div>
        <div className="kicker">404</div>
        <h1 className="font-display text-3xl font-bold tracking-tight text-foreground">
          That page is not part of the platform
        </h1>
        <p className="mx-auto mt-2 max-w-xl text-sm text-muted-foreground">
          The address <span className="font-mono text-foreground/80">{window.location.pathname}</span>{" "}
          does not exist. It may have been mistyped, or the screen you are looking for sits under a
          different section in the sidebar.
        </p>
      </div>
      <Button asChild data-testid="not-found-home"
              className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90">
        <Link to="/dashboard/executive">Back to the overview</Link>
      </Button>
    </div>
  );
}
